export const dummyData = {
    "2022-09-19": {
        "123456": {
            "id": "123456",
            "start": 1,
            "end": 3,
            "title": "Web Development",
            "description": "Learn how to build a website",
            "color": "rgb(198, 252, 193)",
            "date": "2022-09-19"
        },
        "123457": {
            "id": "123457",
            "start": 4,
            "end": 5,
            "title": "Web Development",
            "description": "Start Implementing React",
            "color": "rgb(196, 201, 243)",
            "date": "2022-09-19"
        },
        "123458": {
            "id": "123458",
            "start": 15,
            "end": 18,
            "title": "Temp something something",
            "description": "Start Implementing React",
            "color": "rgb(196, 201, 243)",
            "date": "2022-09-19"
        },
    },
    "2022-09-20": {
        "456789": {
            "id": "456789",
            "start": 2,
            "end": 5,
            "title": "Web Development",
            "description": "Implement a website using react",
            "color": "rgb(198, 252, 193)",
            "date": "2022-09-20"
        },
        "456791": {
            "id": "456791",
            "start": 2,
            "end": 5,
            "title": "Web Development",
            "description": "Implement a website using react",
            "color": "rgb(196, 201, 243)",
            "date": "2022-09-20"
        },
        "456792": {
            "id": "456792",
            "start": 2,
            "end": 6,
            "title": "Web Development 5",
            "description": "Implement a website using react 2",
            "color": "rgb(230, 221, 194)",
            "date": "2022-09-20"
        }
    },
    "2022-09-21": {
        "456789": {
            "id": "456789",
            "start": 14,
            "end": 17,
            "title": "Seva Satva meet",
            "description": "Psychology lecture",
            "color": "rgb(198, 252, 193)",
            "date": "2022-09-21"
        },
        "1234": {
            "id": "1234",
            "start": 10,
            "end": 12,
            "title": "Lecture",
            "description": "Lecture",
            "color": "rgb(198, 252, 193)",
            "date": "2022-09-21"
        }
    },
}

export const tasks = {
    "123456": {
        "id": "123456",
        "start": 1,
        "end": 3,
        "title": "Web Development",
        "description": "Learn how to build a website",
        "color": "rgb(198, 252, 193)",
        "date": "2022-09-19"
    },
    "123457": {
        "id": "123457",
        "start": 4,
        "end": 5,
        "title": "Web Development",
        "description": "Start Implementing React",
        "color": "rgb(196, 201, 243)",
        "date": "2022-09-19"
    },
    "123458": {
        "id": "123458",
        "start": 15,
        "end": 18,
        "title": "Temp something something",
        "description": "Start Implementing React",
        "color": "rgb(196, 201, 243)",
        "date": "2022-09-19"
    },
    "456789": {
        "id": "456789",
        "start": 2,
        "end": 5,
        "title": "Web Development",
        "description": "Implement a website using react",
        "color": "rgb(198, 252, 193)",
        "date": "2022-09-20"
    },
    "456791": {
        "id": "456791",
        "start": 2,
        "end": 5,
        "title": "Web Development",
        "description": "Implement a website using react",
        "color": "rgb(196, 201, 243)",
        "date": "2022-09-20"
    },
    "456792": {
        "id": "456792",
        "start": 2,
        "end": 6,
        "title": "Web Development 5",
        "description": "Implement a website using react 2",
        "color": "rgb(230, 221, 194)",
        "date": "2022-09-20"
    },
    "456710": {
        "id": "456710",
        "start": 14,
        "end": 17,
        "title": "Seva Satva meet",
        "description": "Psychology lecture",
        "color": "rgb(198, 252, 193)",
        "date": "2022-09-21"
    },
    "1234": {
        "id": "1234",
        "start": 10,
        "end": 12,
        "title": "Lecture",
        "description": "Lecture",
        "color": "rgb(198, 252, 193)",
        "date": "2022-09-21"
    }
}